import React from 'react'
// import PropTypes from 'prop-types'

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';


export default class Theme extends React.Component {

  render() {
    const {
      children,
    } = this.props

    const primaryColor = '#002967';
    const secondaryColor = '#495564';
    // const secondaryColor = '#666';
    const theme = createMuiTheme({
      palette: {
        primary: {
          main: primaryColor,
          secondary: '#e43a02',
          dark: primaryColor,
          contrastText: '#fff'
        },
        secondary: {
          main: secondaryColor,
          light: '#fff',
          dark: primaryColor,
          contrastText: '#fff',
        },
        // action: {
        //   active: '#ff0000',
        //   selected: '#ff0000',
        //   hover: '#ff0000',
        // }
      },
      typography: {
        useNextVariants: true,
        // h1: {
        //   fontSize: '3rem',
        //   color: secondaryColor,
        //   textAlign: 'center'
        // },
        // h2: {
        //   marginTop: 30,
        //   paddingTop: 30,
        //   borderTop: '1px #ccc solid',
        //   fontSize: '2.4rem',
        //   color: '#707070',
        // },
        // h3: {
        //   fontSize: '2rem',
        //   color: primaryColor
        // },
        // h4: {
        //   fontSize: '1.815rem'
        // },
        // h5: {
        //   fontSize: '1.6rem',
        //   lineHeight: '1.43'
        // },
        // h6: {
        //   color: '#666',
        //   textAlign: 'center'
        // },
        // mainText: {
          // color: 'red'
        // },
        // body1: {
          // color: 'red'
        // },
        body2: {
          color: '#fff'
        },
        subtitle2: {
          fontSize: '1.075rem'
        }
      },
      breakpoints: {
        values: {
          xs: 0,
          sm: 600,
          md: 960,
          lg: 1280,
          xl: 1920
        }
      },
      overrides: {
        MuiButton: {
          root: {
            color: primaryColor, // Some CSS
            backgroundColor: '#eee'
          },
        },
        // MuiInput: {
        //   root: {
        //     color: primaryColor
        //   },
        //   outlined: {
        //     borderRadius: '30px'
        //   }
        // },
        MuiOutlinedInput: {
          input: {
            paddingLeft: 15,
            paddingRight: 15
            // textAlign: 'center'
          }
        },
        MuiPrivateNotchedOutline: {
          root: {
            borderRadius: '30px',
            overflow: 'hidden',
            textAlign: 'center'
          }
        },
        MuiPaper: {
          rounded: {
            borderRadius: '16px'
          }
        }
      },

    });

// console.log('generated theme', theme)
    // console.log('theme debug', getMuiTheme(getCustomPalette(currentUserGroup)))
    return (
      <MuiThemeProvider theme={theme}>
        {children}
      </MuiThemeProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Theme.jsx